module.exports = __webpack_public_path__ + "media/images/menu/pan-6fcffe3f52b76ed7f6890ffe32fe4ce9.jpg";